export default {
    data() {
        return {
            // getRowClass: {
            //     background: "#F2F2F2"
            // },
        }
    },
    methods: {
        // getRowClass({ row, column, rowIndex, columnIndex }) {
        //     if (rowIndex === 0) {
        //         return "background: #F2F2F2 ";
        //     } else {
        //         return "";
        //     }
        // },
        show(title)
        {
            
        },
        goBack() {
            this.$router.go(-1);
        }
    }
}